import { useQuery } from 'react-query';
import { getLibraryFiles } from '../redux/services/libraryServices';

export const useLibraryFiles = () => {
  return useQuery(['libraryFiles'], async () => {
    const files = await getLibraryFiles();
    return files;
  });
};
